import { render, staticRenderFns } from "./WholesalerOrderDetail.vue?vue&type=template&id=4271d542&scoped=true"
import script from "./WholesalerOrderDetail.vue?vue&type=script&lang=js"
export * from "./WholesalerOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./WholesalerOrderDetail.vue?vue&type=style&index=0&id=4271d542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4271d542",
  null
  
)

export default component.exports